import ExcelJS from "exceljs";
import { BANDERAS } from "./ocrEntregasBanderas";

const COLUMNS = [
  { header: "Archivo", key: "nombre_archivo", width: 38 },
  { header: "Carpeta", key: "carpeta_mes", width: 18 },
  { header: "Tipo", key: "tipo_acta", width: 13 },
  { header: "Fecha archivo", key: "fecha_archivo", width: 14 },
  { header: "Beneficiario OCR", key: "beneficiario_ocr", width: 30 },
  { header: "Beneficiario BD", key: "beneficiario_bd", width: 30 },
  { header: "Identificación", key: "identificacion", width: 16 },
  { header: "Producto OCR", key: "nombre_producto_ocr", width: 35 },
  { header: "Producto BD", key: "nombre_producto_bd", width: 35 },
  { header: "Cantidad", key: "cantidad", width: 11 },
  { header: "N° PO", key: "numero_po", width: 14 },
  { header: "Valor unitario", key: "valor_unitario", width: 15 },
  { header: "Valor total", key: "valor_total", width: 15 },
  { header: "Saldo", key: "saldo", width: 14 },
  { header: "Estado validación", key: "estado_validacion", width: 16 },
  { header: "Creado por", key: "creado_por", width: 16 },
  { header: "Banderas", key: "banderas", width: 55 },
];

const COLUMNS_FINANCIERO = [
  { header: "Proyecto", key: "proyecto", width: 30 },
  { header: "Depto", key: "depto", width: 14 },
  { header: "Municipio", key: "municipio", width: 16 },
  { header: "Id_participante", key: "id_participante", width: 14 },
  { header: "N Participante", key: "n_participante", width: 16 },
  { header: "Nombre Participante", key: "nombre_participante", width: 30 },
  { header: "Id Organización", key: "id_organizacion", width: 14 },
  { header: "N Organización", key: "n_organizacion", width: 16 },
  { header: "Nombre ORG", key: "nombre_org", width: 30 },
  { header: "Producto_id", key: "producto_id", width: 12 },
  { header: "Nombre Producto", key: "nombre_producto", width: 38 },
  { header: "Cantidad", key: "cantidad", width: 11 },
  { header: "Valor", key: "valor", width: 14 },
  { header: "Valor total", key: "valor_total", width: 15 },
  { header: "Saldo", key: "saldo", width: 14 },
  { header: "PO", key: "po", width: 14 },
  { header: "Nombre archivo", key: "nombre_archivo", width: 38 },
  { header: "Carpeta", key: "carpeta", width: 18 },
  { header: "Fecha", key: "fecha", width: 14 },
  { header: "Banderas", key: "banderas", width: 55 },
];

const TITLE_STYLE = {
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FF042956" } },
  font: { bold: true, color: { argb: "FFFFFFFF" }, size: 16 },
  alignment: { vertical: "middle", horizontal: "center" },
};

const SUBTITLE_STYLE = {
  font: { italic: true, color: { argb: "FF555555" }, size: 10 },
  alignment: { vertical: "middle", horizontal: "left" },
};

const HEADER_STYLE = {
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FF042956" } },
  font: { bold: true, color: { argb: "FFFFFFFF" }, size: 11 },
  border: {
    top: { style: "medium", color: { argb: "FF042956" } },
    left: { style: "thin", color: { argb: "FFCCCCCC" } },
    bottom: { style: "medium", color: { argb: "FF042956" } },
    right: { style: "thin", color: { argb: "FFCCCCCC" } },
  },
  alignment: { vertical: "middle", horizontal: "center", wrapText: true, indent: 1 },
};

const dataStyle = (zebra) => ({
  fill: zebra ? { type: "pattern", pattern: "solid", fgColor: { argb: "FFF2F6FA" } } : undefined,
  border: {
    top: { style: "thin", color: { argb: "FFE0E0E0" } },
    left: { style: "thin", color: { argb: "FFE0E0E0" } },
    bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
    right: { style: "thin", color: { argb: "FFE0E0E0" } },
  },
  alignment: { vertical: "middle", horizontal: "left", wrapText: true, indent: 1 },
});

const ESTADO_COLOR = {
  validado: "FF1E7A34",
  rechazado: "FFB42318",
  pendiente: "FFB8740A",
};

const BANDERA_FILL = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFDE2E2" } };

function agregarEncabezado(worksheet, titulo, columnas, totalRegistros) {
  worksheet.mergeCells(1, 1, 1, columnas.length);
  const titleCell = worksheet.getCell(1, 1);
  titleCell.value = titulo;
  titleCell.style = TITLE_STYLE;
  worksheet.getRow(1).height = 28;

  worksheet.mergeCells(2, 1, 2, columnas.length);
  const subtitleCell = worksheet.getCell(2, 1);
  subtitleCell.value = `Generado el ${new Date().toLocaleString("es-CO")} · ${totalRegistros} registro(s)`;
  subtitleCell.style = SUBTITLE_STYLE;
  worksheet.getRow(2).height = 18;

  const headerRow = worksheet.getRow(3);
  headerRow.values = columnas.map((c) => c.header);
  headerRow.height = 24;
  headerRow.eachCell((cell) => {
    cell.style = HEADER_STYLE;
  });

  worksheet.columns = columnas.map((c) => ({ key: c.key, width: c.width }));
  worksheet.autoFilter = { from: { row: 3, column: 1 }, to: { row: 3, column: columnas.length } };
}

function agregarHojaPrincipal(workbook, datos) {
  const worksheet = workbook.addWorksheet("OCR Actas Entrega", {
    views: [{ state: "frozen", ySplit: 3 }],
  });

  agregarEncabezado(worksheet, "Informe OCR de Actas de Entrega", COLUMNS, datos.length);

  datos.forEach((fila, index) => {
    const activas = BANDERAS.filter((b) => fila[b.key]);
    const row = worksheet.getRow(index + 4);
    row.height = 20;

    row.values = {
      nombre_archivo: fila.nombre_archivo || "-",
      carpeta_mes: fila.carpeta_mes || "-",
      tipo_acta: fila.tipo_acta || "-",
      fecha_archivo: fila.fecha_archivo ? String(fila.fecha_archivo).split("T")[0] : "-",
      beneficiario_ocr: fila.nombre_participante_ocr || fila.nombre_organizacion_ocr || "-",
      beneficiario_bd: fila.nombre_participante_bd || fila.nombre_organizacion_bd || "-",
      identificacion: fila.cedula_participante_ocr || fila.nit_organizacion_ocr || "-",
      nombre_producto_ocr: fila.nombre_producto_ocr || "-",
      nombre_producto_bd: fila.nombre_producto_bd || "-",
      cantidad: fila.cantidad ?? "-",
      numero_po: fila.numero_po || "-",
      valor_unitario: fila.valor_unitario ?? "-",
      valor_total: fila.valor_total ?? "-",
      saldo: fila.saldo ?? "-",
      estado_validacion: (fila.estado_validacion || "-").toUpperCase(),
      creado_por: fila.creado_por || "-",
      banderas: activas.length > 0 ? activas.map((b) => b.label).join(", ") : "Sin banderas",
    };

    const estiloFila = dataStyle(index % 2 === 1);
    row.eachCell((cell) => {
      cell.style = estiloFila;
    });

    const celdaEstado = row.getCell("estado_validacion");
    celdaEstado.font = {
      bold: true,
      color: { argb: ESTADO_COLOR[fila.estado_validacion] || "FF555555" },
    };
    celdaEstado.alignment = { vertical: "middle", horizontal: "center" };

    if (activas.length > 0) {
      row.getCell("banderas").fill = BANDERA_FILL;
      row.getCell("banderas").font = { color: { argb: "FF8B0000" }, bold: false };
    }
  });
}

function agregarHojaFinanciera(workbook, datos) {
  const worksheet = workbook.addWorksheet("Reporte Financiero", {
    views: [{ state: "frozen", ySplit: 3 }],
  });

  agregarEncabezado(worksheet, "Reporte Financiero - OCR Actas de Entrega", COLUMNS_FINANCIERO, datos.length);

  datos.forEach((fila, index) => {
    const activas = BANDERAS.filter((b) => fila[b.key]);
    const row = worksheet.getRow(index + 4);
    row.height = 20;

    const proyecto = fila.proyecto_codigo
      ? `${fila.proyecto_codigo} - ${fila.proyecto_nombre || ""}`.trim()
      : fila.proyecto_nombre || fila.oid_proyecto || "-";

    row.values = {
      proyecto,
      depto: fila.departamento_ocr || "-",
      municipio: fila.municipio_ocr || "-",
      // Estas columnas reflejan lo detectado por el OCR (no el dato ya
      // cruzado/corregido en BD), para poder revisar el registro original.
      id_participante: fila.oid_participante ?? "-",
      n_participante: fila.cedula_participante_ocr || "-",
      nombre_participante: fila.nombre_participante_ocr || "-",
      id_organizacion: fila.oid_organizacion ?? "-",
      n_organizacion: fila.nit_organizacion_ocr || "-",
      nombre_org: fila.nombre_organizacion_ocr || "-",
      producto_id: fila.oid_producto ?? "-",
      nombre_producto: fila.nombre_producto_ocr || "-",
      cantidad: fila.cantidad ?? "-",
      valor: fila.valor_unitario ?? "-",
      valor_total: fila.valor_total ?? "-",
      saldo: fila.saldo ?? "-",
      po: fila.numero_po || "-",
      nombre_archivo: fila.nombre_archivo || "-",
      carpeta: fila.carpeta_mes || "-",
      fecha: fila.fecha_archivo ? String(fila.fecha_archivo).split("T")[0] : "-",
      banderas: activas.length > 0 ? activas.map((b) => b.label).join(", ") : "Sin banderas",
    };

    const estiloFila = dataStyle(index % 2 === 1);
    row.eachCell((cell) => {
      cell.style = estiloFila;
    });

    if (activas.length > 0) {
      row.getCell("banderas").fill = BANDERA_FILL;
      row.getCell("banderas").font = { color: { argb: "FF8B0000" }, bold: false };
    }
  });
}

export const exportOcrEntregasExcel = async (datos) => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Bodecom 160 - OCR Actas";
  workbook.created = new Date();

  agregarHojaPrincipal(workbook, datos);
  agregarHojaFinanciera(workbook, datos);

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `ocr_actas_entrega_${new Date().toISOString().split("T")[0]}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
